import { IRootState } from 'app/shared/reducers';
import React from 'react';
import { useSelector } from 'react-redux';
import './loader.scss';

const Loader = () => {
	const { isShowSpinner } = useSelector((state: IRootState) => state.cms);
	return (
		<>
			{isShowSpinner &&
				<div className="loader">
					<svg className="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
						<circle className="circle" fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30"></circle>
					</svg>
				</div>
			}
		</>
	);
}

export default Loader;